// extracted by mini-css-extract-plugin
export var activityContainer = "_l9-0";
export var typingIndicatorContainer = "_l9-1";
export var typingIndicatorDot = "_l9-2";
export var wave = "_l9-3";